module.exports = __webpack_public_path__ + "img/GALLERY-ERTIGA-BOOSTER-GREEN-2.42cbc8e9.jpg";